import React from 'react';
import { withRouter } from 'react-router-dom';
import { Level, Title } from 'rbx';
import styled from 'styled-components';
import { isUndefined } from 'lodash';
import { SubHeading } from '../../../../components/elements';

const Wrapper = styled.div`
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Header = ({ history, placeData }) => (
  <Wrapper>
    <Level style={{ padding: 0, marginTop: 0, marginBottom: 0 }}>
      <Level.Item
        align="left"
        style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
      >
        <Title
          className="is-size-2"
          style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
        >
          Booking Fee Transactions Summary
        </Title>
      </Level.Item>
      <Level.Item
        align="right"
        style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
      >
        <Level.Item style={{ padding: 0, marginTop: 0, marginBottom: 0 }}>
          <a
            onClick={() => history.push(`/table-booking-transactions`)}
            className="button is-primary"
          >
            <span className="has-text-weight-semibold">Go to Listing</span>
          </a>
          <div className="mr-1">&nbsp;</div>
          <a onClick={() => history.goBack()} className="button is-grey">
            <span className="has-text-weight-semibold">Cancel</span>
          </a>
        </Level.Item>
      </Level.Item>
    </Level>
    <SubHeading className="is-size-2">{placeData && placeData.name}</SubHeading>
    {!isUndefined(placeData) && (
      <>
        <SubHeading className="is-size-2">
          {`${placeData && placeData.city}| ${placeData &&
            placeData.state}, ${placeData &&
            placeData.post_code} (${placeData && placeData.status})`}
        </SubHeading>
      </>
    )}
  </Wrapper>
);

export default withRouter(Header);
